import React, {useEffect, useRef} from 'react';
import QRCode from 'qrcodejs2';

interface QRCodeComponentProps {
    value: string;
    size?: number;
    renderScale?: number;
    className?: string;
}

const QRCodeComponent: React.FC<QRCodeComponentProps> = ({
    value,
    size = 128,
    renderScale,
    className
}) => {
    const qrRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (qrRef.current) {
            qrRef.current.innerHTML = '';

            const deviceScale = typeof window !== 'undefined' ? Math.max(1, Math.floor(window.devicePixelRatio || 1)) : 1;
            const effectiveScale = Math.max(1, renderScale ?? deviceScale);
            const renderSize = Math.round(size * effectiveScale);

            new QRCode(qrRef.current, {
                text: value,
                width: renderSize,
                height: renderSize,
            });

            const qrElement = qrRef.current.querySelector('canvas, img') as HTMLElement | null;
            if (qrElement) {
                qrElement.style.width = `${size}px`;
                qrElement.style.height = `${size}px`;
                qrElement.style.display = 'block';
                qrElement.style.imageRendering = 'pixelated';
            }
        }
    }, [value, size, renderScale]);


    return <div ref={qrRef} className={className}></div>;
};

export default QRCodeComponent;
